import React, { useEffect, useState, useRef } from "react";
import { FaBars, FaBell, FaTimes, FaTrash, FaUsers } from "react-icons/fa";
import RoleSidebar from "./RoleSidebar";
import workerAPI from "../api/workerAPI";
import notificationAPI from "../api/notificationAPI";
import { useNavigate } from "react-router-dom";
import FaceWatcher from "./FaceWatcher";
import alertSound from "../assets/alert.mp3";
import WorkerSidebar from "./peopleList";

const TYPE_STYLE = {
  Leave: "bg-blue-100 text-blue-700",
  FaceWatcher: "bg-yellow-100 text-yellow-700",
  AutoLogout: "bg-red-100 text-red-700",
  AdminAlert: "bg-purple-100 text-purple-700",
  default: "bg-gray-100 text-gray-600",
};

const ALERT_TYPES = ["AutoLogout", "AdminAlert", "FaceWatcher"];

const Navbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const prevCountRef = useRef(0);
  const navigate = useNavigate();

  const [worker, setWorker] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("worker"));
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (worker?._id) {
      fetchWorker(worker._id);
      fetchNotifications();
    }
  }, []);

  const fetchWorker = async (id) => {
    try {
      const { data } = await workerAPI.get(`/${id}`);
      setWorker(data);
      localStorage.setItem("worker", JSON.stringify(data));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchNotifications = async () => {
    try {
      const { data } = await notificationAPI.get("/notifications");
      setNotifications(data);
    } catch (err) {
      console.error(err);
    }
  };

  const unreadCount = notifications.filter((n) => !n.read).length;

  const handleBellClick = async () => {
    setShowPopup(!showPopup);
    if (!showPopup) {
      try {
        await notificationAPI.patch("/notifications/read");
        setNotifications((prev) =>
          prev.map((n) => ({ ...n, read: true }))
        );
      } catch (err) {
        console.error(err);
      }
    }
  };

  const enableSound = () => {
    setSoundEnabled(true);
    new Audio(alertSound).play().catch(() => {});
  };

  return (
    <>
      <RoleSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <WorkerSidebar isOpen={showUsers} onClose={() => setShowUsers(false)} />

      {/* NAVBAR */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md px-6 py-3 flex items-center justify-between z-40">

        {/* LEFT */}
        <button
          className="text-2xl text-[#113F67]"
          onClick={() => setSidebarOpen(true)}
        >
          <FaBars />
        </button>

        {/* CENTER TITLE */}
        <h1 className="text-2xl font-bold text-[#113F67] absolute left-1/2 transform -translate-x-1/2">
          MissionMap
        </h1>

        {/* RIGHT SECTION */}
        <div className="flex items-center gap-5">

          {/* Sound */}
          {!soundEnabled ? (
            <button
              onClick={enableSound}
              className="text-xs px-2 py-1 bg-purple-600 text-white rounded"
            >
              🔇 Enable
            </button>
          ) : (
            <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded">
              🔔 On
            </span>
          )}

          {/* Users */}
          <FaUsers
            onClick={() => setShowUsers(true)}
            className="text-xl cursor-pointer hover:text-blue-600"
          />

          {/* Bell */}
          <div className="relative cursor-pointer" onClick={handleBellClick}>
            <FaBell className="text-xl hover:text-purple-600" />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1 rounded-full">
                {unreadCount}
              </span>
            )}
          </div>

          {/* Avatar */}
          {worker?.profileImage && (
            <div className="flex items-center gap-2">
              <img
                src={worker.profileImage}
                alt="user"
                className="w-9 h-9 rounded-full border"
              />
              <span className="text-sm font-semibold">
                {worker.username}
              </span>
            </div>
          )}
        </div>

        {/* NOTIFICATION POPUP */}
        {showPopup && (
          <div className="absolute right-4 top-14 w-80 bg-white shadow-xl rounded-lg border z-50">
            <div className="p-3 font-semibold border-b flex justify-between">
              Notifications
              <FaTimes onClick={() => setShowPopup(false)} />
            </div>

            <ul className="max-h-80 overflow-y-auto">
              {notifications.length > 0 ? (
                notifications.map((n) => (
                  <li
                    key={n._id}
                    className="p-3 border-b text-sm hover:bg-gray-50"
                  >
                    {n.message}
                  </li>
                ))
              ) : (
                <li className="p-4 text-center text-gray-400">
                  No notifications
                </li>
              )}
            </ul>
          </div>
        )}
      </div>

      {/* FaceWatcher */}
      {worker && worker.role !== "Office" && (
        <FaceWatcher />
      )}
    </>
  );
};

export default Navbar;